import { connect } from 'react-redux';

import TranslateTextWidget from './translate_text_widget.jsx';

import {
  getTranslationsIsEnabled,
  getTranslationsCurrentLanguageIso,
  getTranslationsDefaultLanguageIso
} from 'zoomforth_codesbane_viewer/reducers/index.js';

import {
  openTextTranslationModal
} from 'zoomforth_codesbane_editor/action_creators/translations.js';


const mapStateToProps = (state)=> {
  const isTranslationsEnabled = getTranslationsIsEnabled(state);
  const currentLanguageIso = getTranslationsCurrentLanguageIso(state);
  const defaultLanguageIso = getTranslationsDefaultLanguageIso(state);

  const isEditingSecondaryLanguage = currentLanguageIso !== defaultLanguageIso;
  const shouldShowComponent = isTranslationsEnabled && isEditingSecondaryLanguage;

  return { shouldShowComponent };
};

const mapDispatchToProps = (dispatch, {
  text,
  froalaConfig,
  shouldUseFroalaComponent,
  shouldUseTextAreaComponent,
  onTranslationSave
})=> {
  return {
    onTranslateClick: ()=> {
      dispatch(openTextTranslationModal(
        text,
        onTranslationSave,
        {
          froalaConfig,
          shouldUseFroalaComponent,
          shouldUseTextAreaComponent
        }
      ));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TranslateTextWidget);
